export const newOrganizationRoutes = [
  {
    name: 'createOrganization',
    path: '/createOrganization',
    redirect: { name: 'setup' }
  }
]
